import { Package, Users, BookOpen, Calendar, MessageCircle } from "lucide-react";

interface WhatsIncludedSectionProps {
  items: string[];
}

const iconMap = [Package, Users, BookOpen, Calendar, MessageCircle];

export const WhatsIncludedSection = ({ items }: WhatsIncludedSectionProps) => {
  if (!items || items.length === 0) return null;

  return (
    <div className="border-t pt-12 mt-12">
      <h2 className="text-3xl font-bold mb-6">What's Included</h2>
      <div className="grid md:grid-cols-2 gap-6">
        {items.map((item, index) => {
          const Icon = iconMap[index % iconMap.length];
          return (
            <div key={index} className="flex items-start gap-4 p-4 rounded-lg bg-secondary/20">
              <Icon className="w-6 h-6 text-accent flex-shrink-0 mt-0.5" />
              <p className="text-muted-foreground">{item}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};
